import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import {request} from '../../../api-client'
import localization from '../../../config/localization'
import {makeUrlWithTableParams} from "../../../utils";
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";

class FeaturedImagesTable extends Component {

  state = {
    total: '',
  }

  handleAlertClosed = featuredImageId => status => {
    if (status === 'passed') this.refs.table.removeById(featuredImageId)
  }

  buttons = color => {

    const {
      id,
      type,
    } = color

    const editUrl = makeUrlWithTableParams(`/panel/featured_images/${id}/edit`)

    const buttonBuilder = new TableButtonsBuilder()

    buttonBuilder.withEdit(editUrl)
    buttonBuilder.withDelete(localization.get(type), () => request.featuredImage.delete(id), this.handleAlertClosed(id))

    return buttonBuilder.build()
  }

  columns = () => [
    {
      id: 'image',
      accessor: featuredImage => <img alt="Featured Image" src={makeImageUrlWithSize(featuredImage, 'xs')} width={70} height={70} />,
      style: {
        float: 'left',
      },
      resizeable: false,
      sortable: false,
      filterable: false,
      width: 120
    },
    {
      Header: localization.get('table.type'),
      id: "type",
      accessor: featuredImage => localization.get(featuredImage.type),
      Filter: ({ filter, onChange }) => (
        <select
          style={{ width: "100%" }}
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ""}
          placeholder="Buscar por entidad"
        >
          <option value="" selected/>
          <option value="recent">{localization.get('recent')}</option>
          <option value="favorite">{localization.get('favorite')}</option>
          <option value="saved_query">{localization.get('saved_query')}</option>
          <option value="playlist">{localization.get('playlist')}</option>
        </select>
      ),
    },

    {
      Header: localization.get('table.color'),
      accessor: "color",
      Cell: cell => <div style={{ backgroundColor: cell.original.color, height: 40, width: 40}}/>,
      width: 80,
      filterable: false,
      sortable: false,
    },

    {
      id: 'actions',
      sortable: false,
      filterable: false,
      accessor: this.buttons,
      width: 145,
      Footer: <span style={{float: "right", fontSize: "18px", marginTop: "15px"}}><strong>Total:  </strong>{this.state.total}</span>
    }
  ]

  render = () => {
    return (
      <ServerSidePaginationTable
        ref='table'
        columns={this.columns()}
        requestTableData={paginationConfig => request.featuredImage.getAll(paginationConfig).then((response) => {
          this.setState({total: response.meta.total})
          return response
        })}
      />
    )
  }
}

export default FeaturedImagesTable